// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"21dc7c5b","290":"3a410abc","358":"49c35e6a","428":"4d64b9bb","672":"1bac9de5"}[chunkId] + ".chunk.js";
};